import React from 'react';
interface BillSupplierInfoProps {
  supplier: {
    name: string;
    reference: string;
    invoiceDate: string;
    dueDate: string;
    contact?: string;
    email?: string;
    phone?: string;
  };
}
export function BillSupplierInfo({
  supplier
}: BillSupplierInfoProps) {
  return <div className="mb-6 bg-neutral-50 border border-neutral-200 rounded-lg p-5" data-id="element-136">
      <p className="text-xs font-semibold text-neutral-700 mb-3" data-id="element-137">
        SUPPLIER DETAILS:
      </p>
      <div className="grid grid-cols-2 gap-x-8 gap-y-2.5" data-id="element-138">
        <div className="flex" data-id="element-139">
          <span className="text-xs font-medium text-neutral-600 min-w-[120px]" data-id="element-140">
            Bill From:
          </span>
          <span className="text-xs font-semibold text-neutral-900" data-id="element-141">
            {supplier.name}
          </span>
        </div>
        <div className="flex" data-id="element-142">
          <span className="text-xs font-medium text-neutral-600 min-w-[120px]" data-id="element-143">
            Reference:
          </span>
          <span className="text-xs text-neutral-900" data-id="element-144">{supplier.reference}</span>
        </div>
        <div className="flex" data-id="element-145">
          <span className="text-xs font-medium text-neutral-600 min-w-[120px]" data-id="element-146">
            Date:
          </span>
          <span className="text-xs text-neutral-900" data-id="element-147">
            {supplier.invoiceDate}
          </span>
        </div>
        <div className="flex" data-id="element-148">
          <span className="text-xs font-medium text-neutral-600 min-w-[120px]" data-id="element-149">
            Due Date:
          </span>
          <span className="text-xs font-semibold text-neutral-900" data-id="element-150">
            {supplier.dueDate}
          </span>
        </div>
        {supplier.contact && <div className="flex" data-id="element-151">
            <span className="text-xs font-medium text-neutral-600 min-w-[120px]" data-id="element-152">
              Contact:
            </span>
            <span className="text-xs text-neutral-900" data-id="element-153">{supplier.contact}</span>
          </div>}
        {supplier.email && <div className="flex" data-id="element-154">
            <span className="text-xs font-medium text-neutral-600 min-w-[120px]" data-id="element-155">
              Email:
            </span>
            <span className="text-xs text-neutral-900" data-id="element-156">{supplier.email}</span>
          </div>}
        {supplier.phone && <div className="flex" data-id="element-157">
            <span className="text-xs font-medium text-neutral-600 min-w-[120px]" data-id="element-158">
              Phone:
            </span>
            <span className="text-xs text-neutral-900" data-id="element-159">{supplier.phone}</span>
          </div>}
      </div>
    </div>;
}